export function formatTimestamp(timestamp: string): string {
  const parsed = new Date(timestamp);

  return Number.isNaN(parsed.getTime())
    ? timestamp
    : parsed.toLocaleString("nb-NO", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });
}
